"use strict";var e=require("./get/index.js");module.exports=s=>e(Object.assign(Object.assign({},s),{skip:!s.token}));
//# sourceMappingURL=index.js.map
